export default __webpack_public_path__ + "static/media/hsk.7aa11da7.png";